import { render, staticRenderFns } from "./ModalTelefono.vue?vue&type=template&id=6f195f7e"
import script from "./ModalTelefono.vue?vue&type=script&lang=js"
export * from "./ModalTelefono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f195f7e')) {
      api.createRecord('6f195f7e', component.options)
    } else {
      api.reload('6f195f7e', component.options)
    }
    module.hot.accept("./ModalTelefono.vue?vue&type=template&id=6f195f7e", function () {
      api.rerender('6f195f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/ModalTelefono.vue"
export default component.exports